import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getYearOptions } from '../../services/dateServices';
import Api from '../../../../Global/Modules/Api'

const FETCH_URL = "api/educations/membership"
class LidstudiecelAdd extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            errors: {}
        }
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var payload = {}
        const formData = event.target.elements
        for (var i = 0; i < formData.length; i++) {
            const e = formData[i] // Form element
            const name = e.name
            const value = e.value

            if (name && value)
                payload[name] = value
        }
        payload['type'] = 'studycell';
        // TODO: Post payload to the API
        Api.PostApi(FETCH_URL, payload, this.props.history)
            .then(response => {
                alert("Lidstudiecel added")
                window.location.href = '/kennis/beheren'


            })

    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <               FormGroup controlId="LidstudiecelNaamStudiecel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam studiecel:
                        {/* Only show this field when the last option is selected: Overig: vrij in te vullen, geen punten toewijzing */}
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" required />
                        {/* {Api.showError(errors, "activities")} */}
                    </Col>
                </FormGroup>

                <FormGroup controlId="LidstudiecelProjectCaseNaam">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam project/case:
                        {/* Only show this field when the last option is selected: Overig: vrij in te vullen, geen punten toewijzing */}
                    </Col>
                    <Col sm={6}>
                        <FormControl name="overig" type="text" required />
                        {/* {Api.showError(errors, "activities")} */}
                    </Col>
                </FormGroup>

                <FormGroup controlId="Lidstudiecel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Toelichting:
                        {/* Only show this field when the last option is selected: Overig: vrij in te vullen, geen punten toewijzing */}
                    </Col>
                    <Col sm={6}>
                        <FormControl name="description" type="text" required />
                        {/* {Api.showError(errors, "activities")} */}
                    </Col>
                </FormGroup>

                <FormGroup controlId="LidstudiecellidVan">
                    <Col componentClass={ControlLabel} sm={4}>
                        Van
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearInit" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "from")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="LidstudiecellidTot">
                    <Col componentClass={ControlLabel} sm={4}>
                        T/m
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "to")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default LidstudiecelAdd;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/LidstudiecelAdd.js